import { ILeagueConfig } from 'fitbeat.models';
import React from 'react';
import ReactTable from 'react-table';
import { MemberTableHeader } from '../../../members/components/memberTableHeader';

interface ILeagueTableProps {
  leagues: ILeagueConfig[];
  selectedLeagueIndex: number | null;
  onSelectLeague: (index: number) => void;
}

const LeagueTable: React.FC<ILeagueTableProps> = ({
  leagues,
  selectedLeagueIndex,
  onSelectLeague,
}) => {
  const columns = [
    {
      Header: () => <MemberTableHeader header='ID' />,
      accessor: 'id',
      minWidth: 150,
    },
    {
      Header: () => <MemberTableHeader header='Display Name' />,
      accessor: 'displayName',
      minWidth: 200,
    },
    {
      Header: () => <MemberTableHeader header='Primary Colour' />,
      accessor: 'primaryColour',
      minWidth: 150,
      Cell: (row: { value?: string }) => row.value ?? '-',
    },
  ];

  return (
    <div className='leaderboards-table'>
      <ReactTable
        className='clickable-row'
        minRows={0}
        resizable
        filterable
        data={leagues}
        showPagination={false}
        defaultPageSize={1000}
        loadingText='Loading...'
        noDataText='No leagues configured'
        columns={columns}
        getTrGroupProps={(state: any, rowInfo: any) => {
          if (!rowInfo) {
            return {};
          }
          const index = leagues.indexOf(rowInfo.original);
          return {
            onClick: () => {
              if (index !== -1) {
                onSelectLeague(index);
              }
            },
            className: index === selectedLeagueIndex ? 'selected-config-row' : '',
          };
        }}
      />
    </div>
  );
};

export default LeagueTable;
